import { IPasswordResetCredentials } from "../../model/authentication/PasswordResetCredentials";
import { ICredentialService } from "../../service/credential/CredentialService";

export default class RequestPasswordResetInteractor {
  private credentialService: ICredentialService;

  constructor({
    credentialService
  }: {
    credentialService: ICredentialService;
  }) {
    this.credentialService = credentialService;
  }

  async execute(credentials: IPasswordResetCredentials, language: string) {
    return this.credentialService.resetPassword(credentials, language);
  }
}
